import React from 'react';
import { TopBar } from '../components/TopBar';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Ticker } from '../components/Ticker';
import { Mission } from '../components/Mission';
import { UseCases } from '../components/UseCases';
import { Materials } from '../components/Materials';
import { Product } from '../components/Product';
import { WhatsInBox } from '../components/WhatsInBox';
import { SocialProof } from '../components/SocialProof';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { FloatingElements } from '../components/FloatingElements';
export const Home = () => {
  return <div className="relative" data-id="element-765">
      <TopBar data-id="element-766" />
      <Navigation data-id="element-767" />

      <main data-id="element-768">
        <Hero data-id="element-769" />
        <Ticker data-id="element-770" />
        <Mission data-id="element-771" />

        <UseCases data-id="element-772" />
        <WhatsInBox data-id="element-773" />
        <Materials data-id="element-774" />
        <Product data-id="element-775" />
        <Guarantee data-id="element-776" />
        <FAQ data-id="element-777" />
        <SocialProof data-id="element-778" />
        <Contact data-id="element-779" />
      </main>

      <Footer data-id="element-780" />
      <FloatingElements data-id="element-781" />
    </div>;
};